import { Power1, gsap } from 'gsap';
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MainContext } from '../../../../context';
import routes from '../../../../routes';
import { getUserData } from '../../../../services/general';
import {
  StaticButton,
  StaticMenuColRight,
  StaticMenuContainer,
  StaticMenuWrapper,
  Wrapper,
} from '../../../Admin/layout';

export const UserStaticNavigation = ({ top, activeUser, setActiveUser, setSubdomainAgent, setError }) => {
  const navigate = useNavigate();
  const fetchUser = async () => {
    const result = await getUserData();
    if (result.message === 'Unauthenticated.') navigate(routes.userLogin());
    else {
      setActiveUser({ ...result.user, favorites: result.user.communities.map((c) => c.community_id) });
      if (result.user.hasOwnProperty('agent')) {
        setSubdomainAgent(result.user.agent);
      }
    }
  };
  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StaticMenuContainer top={top}>
      <StaticMenuWrapper>
        <div>
          <h3>Hello {activeUser?.name}!</h3>
        </div>
        <StaticMenuColRight>
          <StaticButton onClick={() => navigate('/user/dashboard')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <path
                d="M12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0ZM8.17108 7.14265H16.8274C17.41 7.1821 17.8496 7.60602 17.8574 8.14363V16.8289C17.8161 17.4343 17.3756 17.85 16.8274 17.8574H8.17108C7.56608 17.8161 7.15 17.3767 7.14265 16.8289V8.14363C7.17602 7.56381 7.65871 7.14952 8.17108 7.14265ZM9.62829 9.11408C9.31765 9.12179 9.11733 9.36088 9.11406 9.62983V15.3427C9.12213 15.6528 9.36006 15.8552 9.62829 15.8585H15.3702C15.681 15.8504 15.8827 15.6115 15.8859 15.3427V9.62981C15.8783 9.31846 15.6398 9.11727 15.3702 9.11406H9.62829V9.11408Z"
                fill="#04246B"
              />
            </svg>
            <span>Home</span>
          </StaticButton>
          <StaticButton onClick={() => navigate('/user/favorites')}>
            <svg
              style={{ height: 25 }}
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="32"
              viewBox="0 0 26 32"
              fill="none"
            >
              <path
                d="M13.0015 0.333252C7.89185 0.333252 3.70435 4.50825 3.70435 9.60388C3.70435 11.5783 4.33497 13.4133 5.40216 14.9214L11.8668 26.0973C12.7722 27.2801 13.374 27.0554 14.1268 26.0348L21.2575 13.9004C21.4012 13.6398 21.5143 13.3623 21.6128 13.0789C22.0653 11.9762 22.298 10.7958 22.2978 9.60388C22.2981 4.50825 18.1118 0.333252 13.0015 0.333252ZM13.0015 4.677C15.7534 4.677 17.9415 6.86013 17.9415 9.60388C17.9415 12.3476 15.7534 14.5298 13.0015 14.5298C10.25 14.5298 8.06091 12.3479 8.06091 9.60388C8.06091 6.86013 10.25 4.677 13.0015 4.677Z"
                fill="#04246B"
              />
              <path
                d="M13.0077 16.8958L12.9927 16.9351C12.9974 16.9233 13.0011 16.9111 13.0058 16.8992L13.0077 16.8958Z"
                fill="#04246B"
              />
              <path
                d="M8.00187 21.9348C3.5875 22.5586 0.5 24.0508 0.5 26.2473C0.5 29.2061 5.65875 31.6045 13 31.6045C20.3413 31.6045 25.5 29.2061 25.5 26.2473C25.5 24.0508 22.4128 22.5586 17.9988 21.9348L17.3872 22.9761C20.7141 23.4376 23 24.4076 23 25.5333C23 27.1114 18.5228 28.3904 13 28.3904C7.47719 28.3904 3 27.1114 3 25.5333C2.99969 24.4114 5.27063 23.4423 8.60781 22.9789C8.40625 22.6308 8.20375 22.2833 8.00187 21.9348Z"
                fill="#04246B"
              />
            </svg>
            <span>Favorites</span>
          </StaticButton>
          <StaticButton onClick={() => (window.location.href = '/admin/logout')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <path
                d="M13.2406 13.7504L10.3649 16.6136C10.2477 16.7298 10.1547 16.8681 10.0913 17.0205C10.0278 17.1728 9.9951 17.3362 9.9951 17.5013C9.9951 17.6664 10.0278 17.8298 10.0913 17.9821C10.1547 18.1345 10.2477 18.2728 10.3649 18.389C10.4812 18.5062 10.6194 18.5992 10.7718 18.6627C10.9242 18.7262 11.0876 18.7588 11.2526 18.7588C11.4177 18.7588 11.5811 18.7262 11.7335 18.6627C11.8858 18.5992 12.0241 18.5062 12.1404 18.389L17.1415 13.3878C17.2554 13.2689 17.3446 13.1287 17.4041 12.9752C17.5291 12.6708 17.5291 12.3294 17.4041 12.025C17.3446 11.8715 17.2554 11.7313 17.1415 11.6124L12.1404 6.61125C12.0238 6.49467 11.8854 6.4022 11.7331 6.33911C11.5808 6.27602 11.4175 6.24355 11.2526 6.24355C11.0878 6.24355 10.9245 6.27602 10.7722 6.33911C10.6199 6.4022 10.4815 6.49467 10.3649 6.61125C10.2484 6.72782 10.1559 6.86622 10.0928 7.01853C10.0297 7.17084 9.99723 7.33409 9.99723 7.49896C9.99723 7.66382 10.0297 7.82707 10.0928 7.97938C10.1559 8.13169 10.2484 8.27009 10.3649 8.38666L13.2406 11.2498H1.25029C0.918695 11.2498 0.600678 11.3816 0.366202 11.616C0.131727 11.8505 0 12.1685 0 12.5001C0 12.8317 0.131727 13.1497 0.366202 13.3842C0.600678 13.6187 0.918695 13.7504 1.25029 13.7504H13.2406ZM12.5029 -0.00280504C10.1663 -0.0132372 7.8734 0.63136 5.88447 1.85787C3.89553 3.08438 2.29011 4.84372 1.25029 6.93632C1.10107 7.23476 1.07652 7.58025 1.18203 7.8968C1.28755 8.21334 1.51449 8.475 1.81293 8.62422C2.11136 8.77344 2.45686 8.79799 2.7734 8.69248C3.08994 8.58696 3.3516 8.36003 3.50082 8.06159C4.29125 6.46536 5.49358 5.10917 6.98358 4.13315C8.47357 3.15713 10.1972 2.5967 11.9763 2.50977C13.7553 2.42285 15.5254 2.81258 17.1034 3.63869C18.6815 4.4648 20.0103 5.69732 20.9526 7.20888C21.8948 8.72044 22.4164 10.4562 22.4633 12.2368C22.5102 14.0174 22.0808 15.7782 21.2194 17.3373C20.358 18.8964 19.0959 20.1971 17.5635 21.1052C16.0312 22.0132 14.2841 22.4956 12.5029 22.5025C10.6386 22.5105 8.80976 21.9928 7.22631 21.0087C5.64286 20.0246 4.36897 18.6139 3.55083 16.9387C3.40161 16.6402 3.13995 16.4133 2.82341 16.3078C2.50687 16.2023 2.16138 16.2268 1.86294 16.376C1.5645 16.5253 1.33756 16.7869 1.23205 17.1035C1.12653 17.42 1.15109 17.7655 1.30031 18.0639C2.29157 20.0588 3.79779 21.7526 5.66317 22.9701C7.52854 24.1877 9.68533 24.8848 11.9104 24.9893C14.1356 25.0938 16.3482 24.602 18.3195 23.5646C20.2908 22.5273 21.9491 20.9821 23.123 19.089C24.2969 17.1958 24.9437 15.0234 24.9965 12.7965C25.0493 10.5695 24.5062 8.3689 23.4233 6.42224C22.3404 4.47558 20.7572 2.85357 18.8373 1.72398C16.9173 0.594391 14.7305 -0.00175923 12.5029 -0.00280504Z"
                fill="#04246B"
              />
            </svg>
            <span>Logout</span>
          </StaticButton>
        </StaticMenuColRight>
      </StaticMenuWrapper>
    </StaticMenuContainer>
  );
};

const Layout = ({ children }) => {
  const { activeUser, setActiveUser, openSidebar, setSubdomainAgent } = useContext(MainContext);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [top, setTop] = useState(116);

  const fetchUser = async () => {
    try {
      const result = await getUserData();
      if (result.message === 'Unauthenticated.') navigate(routes.userLogin());
      else {
        setActiveUser({ ...result.user, favorites: result.user.communities.map((c) => c.community_id) });
      }
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  useEffect(() => {
    gsap.to('.sidebar-open', {
      left: openSidebar ? 0 : '-100%',
      ease: Power1.easeInOut,
      duration: 0,
    });
  }, [openSidebar]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY >= 165) {
        setTop(0);
      } else {
        setTop(116);
      }
    });
  }, []);
  useLayoutEffect(() => {
    const gctx = gsap.context(() => {});
    return () => gctx.revert();
  }, []);

  return (
    <div>
      {!error && activeUser && (
        <>
          <UserStaticNavigation
            top={top}
            activeUser={activeUser}
            setActiveUser={setActiveUser}
            setSubdomainAgent={setSubdomainAgent}
          />
          <Wrapper>{children}</Wrapper>
        </>
      )}
    </div>
  );
};

export default Layout;
